import type { Route } from '~/interfaces/routes.interfaces'

export const INDEX: Route = {
  path: '/'
}

export const LOGIN: Route = {
  path: '/login'
}

export const FORGOT_PASSWORD: Route = {
  path: '/forgot-password'
}
